import React, { useEffect, useState } from "react";
import Layout from "../components/Layout";
import SidebarLayout from "../components/Sidebar";
import MyTonesLibrary from "../components/MyTonesLibrary";
import axios from "axios";
import { useSelector } from "react-redux";
import { RootState } from "../redux/store";

const MyTones = () => {
  const [rbtDetails, setRbtDetails] = useState([]);

  const { countryCode, msisdn } = useSelector(
    (state: RootState) => state.phone
  );

  const { subType, planId } = useSelector((state: RootState) => state.profile);

  const getMyLibraryTones = async () => {
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/Profile/MyTones?msisdn=${
        countryCode + msisdn
      }&service=${process.env.REACT_APP_SERVICE}&interface=${
        process.env.REACT_APP_INTERFACES
      }&langId=${process.env.REACT_APP_LANGID}`
    );
    setRbtDetails(res.data.crbtProfile.toneList);
  };

  const handleDeleteTone = async (rbtCode: string) => {
    try {
      const url = `${process.env.REACT_APP_API_URL}/Purchase/DeleteRBT?msisdn=${
        countryCode + msisdn
      }&service=${process.env.REACT_APP_SERVICE}&interface=${
        process.env.REACT_APP_INTERFACES
      }&langId=${
        process.env.REACT_APP_LANGID
      }&rbtCode=${rbtCode}&planId=${planId}&subType=${subType}`;

      const res = await fetch(url, {
        method: "DELETE",
      });

      const data = await res.json();

      if (data?.resCode === 229) {
        alert(data?.resMessage);
        getMyLibraryTones();
      } else {
        alert(data?.resMessage || "Failed to delete tone");
      }
    } catch (err) {
      console.error("Delete API Error:", err);
      alert("Something went wrong!");
    }
  };

  useEffect(() => {
    getMyLibraryTones();
  }, []);

  return (
    <Layout>
      <SidebarLayout>
        <MyTonesLibrary
          myToneList={rbtDetails}
          successMessage="Tone set successfully!"
          onDelete={handleDeleteTone}
          // onSet={(tone) => console.log("Set", tone)}
        />
      </SidebarLayout>
    </Layout>
  );
};

export default MyTones;
